import { asyncStorageCookie } from './async-storage-cookie';
import { OE_SSO_TOKEN_COOKIE_NAME } from './oe-sso-cookie';

export const oeSsoCookieAsyncStorage = asyncStorageCookie(
  OE_SSO_TOKEN_COOKIE_NAME
);
